import React, { useEffect, useState } from "react";
import { Tabs, Col } from "antd";
import AdminMainLayout from "../AdminMainLayout";
import ProductSearch from "./ProductSearch";
import SpaceSearch from "./SpaceSearch";
import MaterialSearch from "./MaterialSearch";
const { TabPane } = Tabs;

const SearchItem = () => {
    const [tabActiveKey, setTabActiveKey] = useState('product');
    const [tabParams, setTabParams] = useState({});
    const tabs = [
        {
          key: 'product',
          title: 'Product',
          Component: (() => {
            return (
            <ProductSearch>
            </ProductSearch>
            )
          })
        },
        {
          key: 'space',
          title: 'Space',
          Component: (() => {
            return (
            <SpaceSearch>
            </SpaceSearch>
            )
          })
        },
        {
          key: 'material',
          title: 'Material',
          Component: (() => {
            return (
            <MaterialSearch>
            </MaterialSearch>
            )
          })
        }
      ];
    
    const handleTabChange = (key) => {
        // Save current tab's params before switching
        const currentParams = new URLSearchParams(window.location.search);
        const currentTabParams = {};
        currentParams.forEach((value, param) => {
            if (param !== 'tab') {
                currentTabParams[param] = value;
            }
        });
        
        // Store current tab's params
        setTabParams(prev => ({
            ...prev,
            [tabActiveKey]: currentTabParams
        }));
        
        setTabActiveKey(key);
    };

    useEffect(() => {
        // Read the tab from URL params on component mount
        const params = new URLSearchParams(window.location.search);
        const tabFromUrl = params.get("tab");
        
        // If there's a tab in the URL and it's valid, set it as active
        if (tabFromUrl && tabs.some(tab => tab.key === tabFromUrl)) {
            setTabActiveKey(tabFromUrl);
        }
        
        // Store initial params for the current tab
        const initialTabParams = {};
        params.forEach((value, param) => {
            if (param !== 'tab') {
                initialTabParams[param] = value;
            }
        });
        
        if (Object.keys(initialTabParams).length > 0) {
            setTabParams(prev => ({
                ...prev,
                [tabFromUrl || 'product']: initialTabParams
            }));
        }
    }, []); // Empty dependency array - runs only on mount

    useEffect(() => {
        const params = new URLSearchParams();
        params.set("tab", tabActiveKey);
        
        // Restore saved params for this tab if they exist
        if (tabParams[tabActiveKey]) {
            Object.entries(tabParams[tabActiveKey]).forEach(([param, value]) => {
                params.set(param, value);
            });
        }
        
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [tabActiveKey, tabParams])

    return (
        <AdminMainLayout selected={'23'}>
            <Col span={24}>
                <Tabs
                onChange={(key) => handleTabChange(key)}
                tabBarGutter={16}
                size="large"
                className="product-tab library"
                activeKey={tabActiveKey}>
                    {
                        tabs?.map((tab) => {
                            return (
                                <TabPane tab={tab.title} key={tab.key} style={{ padding: "0px 10px" }}> 
                                {
                                    tab.Component()
                                }
                                </TabPane>
                            )
                        })
                    }  
                </Tabs>
            </Col>
        </AdminMainLayout>
    )
}

export default SearchItem;